export enum OrderBy {
  Headword = 1,
  UpdateDate = 2,
}
